import { render, staticRenderFns } from "./ChangeView.vue?vue&type=template&id=36692a8c"
import script from "./ChangeView.vue?vue&type=script&lang=js"
export * from "./ChangeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports